import script from "./financialService.vue?vue&type=script&lang=ts&setup=true"
export * from "./financialService.vue?vue&type=script&lang=ts&setup=true"

import "./financialService.vue?vue&type=style&index=0&id=2c1db5ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c1db5ae"]])

export default __exports__